'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('@iyunbao/utils');

var _toast = require('../../toast');

var _toast2 = _interopRequireDefault(_toast);

var _fetch = require('../../utils/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _config = require('../../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 文档 https://infernal.zhonganinfo.com/document

var AntiBrush = function (_PureComponent) {
  _inherits(AntiBrush, _PureComponent);

  function AntiBrush(props) {
    _classCallCheck(this, AntiBrush);

    var _this = _possibleConstructorReturn(this, (AntiBrush.__proto__ || Object.getPrototypeOf(AntiBrush)).call(this, props));

    _this.loadJS = function () {
      return new Promise(function (resolve) {
        if (typeof SuperCode !== 'undefined') {
          resolve();
          return false;
        }

        _utils.load.css('https://staticdaily.zhongan.com/website/paas/public/supercode/1.0.9/supercode.css');
        _utils.load.js('https://staticdaily.zhongan.com/website/paas/public/supercode/1.0.9/supercode.js', function () {
          resolve();
        });
      });
    };

    _this.ceate = function () {
      var onClose = _this.props.onClose;
      var sId = _this.props.sId;

      var reg = new RegExp('^(.+)#(.+)$');
      var env = (0, _config.getEnv)();

      // 目前只有测试和生产环境
      if (!['dev', 'pre'].indexOf(env)) {
        env = 'test';
      }

      // 添加环境，方便开启自动化测试
      if (reg.test(sId)) {
        sId = sId.replace(reg, '$1#' + env + '#$2');
      }

      _this.loadJS().then(function () {
        var code = new window.SuperCode({
          scene: sId,
          onFinaly: function onFinaly(data) {
            if (+data.code === 0 && data.data) {
              _this.verify(data.data);
              // code=13 用户取消操作
            } else if (+data.code !== 13 && data.message) {
              _toast2.default.warning(data.message);
            }

            onClose();
          }
        });

        code.show();
      });
    };

    _this.verify = function (params) {
      var _this$props = _this.props,
          bizType = _this$props.bizType,
          data = _this$props.data,
          sTokenId = _this$props.sTokenId,
          onSuccess = _this$props.onSuccess,
          onClose = _this$props.onClose;

      // key 调整sid

      if (params.scene) {
        params.sid = params.scene;
        delete params.scene;
      }

      _fetch2.default.fetch({
        path: '/facilities/open/v1/common/security/wjd/ticket',
        server: 'api',
        method: 'POST',
        data: _extends({}, params, {
          bizType: bizType,
          data: data,
          sTokenId: sTokenId
        })
      }).then(function (_ref) {
        var code = _ref.code,
            result = _ref.result,
            message = _ref.message;

        if (+code === 0 && result) {
          onSuccess(result.ticket, data);
        } else {
          onClose && onClose();
          message && _toast2.default.warning(message);
        }
      }).catch(function () {
        onClose && onClose();
      });
    };

    _this.state = {};

    _this.prefixClsModal = 'cui-modal';

    _this.ceate();
    return _this;
  }

  _createClass(AntiBrush, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return AntiBrush;
}(_react.PureComponent);

AntiBrush.defaultProps = {
  data: '',
  bizType: '',
  sTokenId: '',
  sId: '',
  onSuccess: function onSuccess() {},
  onClose: function onClose() {}
};
AntiBrush.propTypes = {
  data: _propTypes2.default.string,
  bizType: _propTypes2.default.string,
  sTokenId: _propTypes2.default.string,
  sId: _propTypes2.default.string,
  onSuccess: _propTypes2.default.func,
  onClose: _propTypes2.default.func
};
exports.default = AntiBrush;